import Joi from 'joi';

const resourceSchema = Joi.object({
  category: Joi.number().required(),
  title: Joi.string().max(50).required(),
  description: Joi.string().max(150).required(),
  link: Joi.string().uri().required(),
  permissions: Joi.array().required()
}).unknown();

const ResourcePageValidator = {
  addSchema: resourceSchema,
  editSchema: Joi.object({
    resources: Joi.array().items(resourceSchema)
  })
};

export default ResourcePageValidator;
